module.exports = __webpack_public_path__ + "img/4680.2abf03c2.jpg";